import React from "react";
import { Card } from "react-bootstrap";
import "./productCard.css";
import Capacity from "../../assets/capacity.svg";
import sineWave from "../../assets/wave.svg";
import squareWave from "../../assets/squareWave.svg";
import constants from "../../constants/Contents.json";
import Solar from "../../assets/icons/Solar";
import Connectivity from "../../assets/icons/Connectivity";
import ButtonComponent from "../Button/Button";
import { style } from "framer-motion/client";

const ProductCard = ({
  product,
  onClick,
  clickOnBuy,
  style,
  disable = true,
  match = true,
}) => {
  const staticContent = constants.ProductCard;
  const capitalizeWords = (input) => {
    if (!input) {
      return "";
    }
    return input.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  };
  return (
    <div onClick={onClick}>
      <Card className="card-main" style={style}>
        {match && (
          <div className="product-match">
            {product.matchingPercent}
            {staticContent.Match}
          </div>
        )}

        <div className="product-image">
          <img src={product?.image} alt="Product" />
        </div>

        <Card.Body>
          <div className="product-name">{product?.name}</div>
          <div className="body">
            <div className="text-with-img">
              <img src={Capacity} alt="Capacity Icon" />
              {product?.powerInVoltAmperes}
              {staticContent.powerVa}
            </div>
            <div className="text-with-img">
              {product?.type === "SINE WAVE" ? (
                <img src={sineWave} alt="Sine Wave Icon" />
              ) : (
                <img src={squareWave} alt="Square Wave Icon" />
              )}
              {capitalizeWords(product?.type)}
            </div>
            <div>
              <div
                className={`text-with-img ${
                  product?.mobileConnectivity === true
                    ? "active-choice-img"
                    : "inactive-choice-img"
                }`}
              >
                <Connectivity />
                <div> {capitalizeWords(staticContent.connectivity)}</div>
              </div>
            </div>
            {/* Solar */}
            <div>
              <div
                className={`text-with-img ${
                  product?.solarModel === true
                    ? "active-choice-img"
                    : "inactive-choice-img"
                }`}
              >
                <Solar />
                <div> {capitalizeWords(staticContent.solar)}</div>
              </div>
            </div>
          </div>
          <div className="buttonProduct">
            <ButtonComponent
              buttonText={
                disable ? staticContent.buttonCom : staticContent.buttonIn
              }
              className={"letsPlan"}
              onClick={clickOnBuy}
            />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProductCard;
